import React from 'react'
import { Controller } from 'react-hook-form'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import Checkbox from '@material-ui/core/Checkbox'
import FormControl from '@material-ui/core/FormControl'
import { useController } from 'react-hook-form'
import { HelperText } from '../../form/components/inputs'

const MultiSelectWithCheckboxes_expertise = ({
  control,
  name,
  label,
  options,
  t,
  className,
  defaultValue,
  disabled,
  setIsDirty
}) => {
  const {
    fieldState: { invalid, error }
  } = useController({
    name,
    control,
    defaultValue: defaultValue ?? []
  })
  return (
    <FormControl error={invalid} style={{ marginTop: '32px' }}>
      <InputLabel shrink style={{ marginTop: '-8px', fontSize: '20px' }}>
        {label}
      </InputLabel>
      <Controller
        name={name}
        control={control}
        defaultValue={[]}
        render={({ field }) => (
          <>
            <Select
              multiple
              value={field.value}
              className={className}
              onChange={(e) => {
                field.onChange(e.target.value)
                setIsDirty(true)
              }}
              label={label}
              renderValue={(selected) => {
                const selectedLabels = selected.map(
                  (id) => options.find((option) => option.Id === id)?.Id
                )
                return (
                  t(`areaOfExpertiseList.${selectedLabels[0]}`) +
                  (selected.length > 1
                    ? ` + ${selected.length - 1} ${t('openForWork.more')}`
                    : '')
                )
              }}
              MenuProps={{
                getContentAnchorEl: null,
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left'
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left'
                },
                style: {
                  maxHeight: '400px'
                }
              }}
              disabled={disabled}
            >
              {options.map((option) => (
                <MenuItem
                  key={option.Id}
                  value={option.Id}
                  style={{ paddingRight: '0 !important' }}
                >
                  <Checkbox
                    color="primary"
                    checked={field.value.includes(option.Id)}
                  />
                  {t(`areaOfExpertiseList.${option.Id}`)}
                </MenuItem>
              ))}
            </Select>
            <HelperText
              invalid={invalid}
              error={error}
              style={{ marginTop: '0px', height: '0px' }}
            />
          </>
        )}
      />
    </FormControl>
  )
}

export default MultiSelectWithCheckboxes_expertise
